import React, {MouseEventHandler, useCallback, useContext, useState} from 'react';
import {getLang, getTranslations} from '../../translations';
import appConfig from '../../app.config';
import {useFeatureServices} from '../../use-feature-services';
import {
  createConfiguration,
  createConstantData,
  createPartner,
  createProcess,
} from '../../utils/get-tracking-event-data';
import {
  CTA,
  Spinner,
} from '@volkswagen-onehub/components-core';
import {LayerCloseHandle} from '../../types/layers';
import VKWrapper from '../VKWrapper';
import { useDealersStore } from '../../utils/use-dealers-store';
import { useAppliedFilterStore } from '../../store/filtersv2';
import { AppContext } from '../../app-context';

const FactoryOrderModal = ({close}: {close: LayerCloseHandle}) => {
  const { globalApi } = useContext(AppContext);
  const {tracking} = useFeatureServices();
  const [onRequest, setOnRequest] = useState<boolean>(false);

  const { localDealer } = useDealersStore();
  const { model } = useAppliedFilterStore().applied;
  const lang = getLang();

  const trans = getTranslations();

  const onPreOrder = useCallback(
    async (e: React.SyntheticEvent<HTMLButtonElement>) => {
      const linkName = e.currentTarget.innerText;
      if (!localDealer || !model) return;
      setOnRequest(true);

      let clonedModel = [...model];

      if (clonedModel.length) {
        const modelNames: {[k: string]: string} = appConfig.models;

        clonedModel.forEach((model, i) => {
          if (Object.keys(modelNames).includes(model)) {
            clonedModel[i] = modelNames[model];
          }
        });
      }

      const body = {
        dealership_oem_code: localDealer.dealer_id,
        language: lang.toLocaleUpperCase(),
        redirect_type: 'Showroom',
        vehicle_data: {
          make: ['Volkswagen'],
          model: clonedModel,
        },
        order_configuration: {
          accessories: [],
          incentives: [],
          protection_plans: [],
          payment_data: {},
        },
      };

      const request = await fetch(
        globalApi + '/inventory-app/motoinsight-lead',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'content-language': lang,
          },
          body: JSON.stringify(body),
        }
      );

      if (request.ok) {
        const response = await request.json();
        if (response.redirect_target) {
          window.open(response.redirect_target, '_blank')?.focus();
          tracking.track('VWBasic_Button_Click', {
            ...createConstantData(),
            configuration: createConfiguration(),
            partner: createPartner(localDealer),
            process: createProcess('2A'),
            link: {
              url: response.redirect_target,
              name: linkName,
            },
          });
        }
      }
      setOnRequest(false);
    },
    [localDealer]
  );

  return model ? (
    <VKWrapper>
      {onRequest ? (
        <Spinner />
      ) : (
        <CTA tag="button" onClick={onPreOrder}>
          {trans.details.motoinsights.continue}
        </CTA>
      )}

      <CTA
        tag="button"
        emphasis="tertiary"
        onClick={close as unknown as MouseEventHandler<HTMLButtonElement>}
      >
        {trans.details.motoinsights.cancel}
      </CTA>
    </VKWrapper>
  ) : null;
};

export default FactoryOrderModal;
